// // import React, { useEffect, useRef, useState } from "react";
// // import "datatables.net-fixedcolumns";
// // import { useTranslation } from "react-i18next";
// // import Slider from "rc-slider";

// // import { _Api } from "../../components/api/_call";
// // import "./NewFilterModal.scss";

// // const NewFilterModal = (props) => {
// //   const {
// //     submitfiltter,
// //     limit,
// //     custom_filter_enable,
// //     stockTakeFliterisOpen,
// //     setStockTakeFliterIsOpen,
// //     setLocationFilter,
// //   } = props;
// //   const { t } = useTranslation();
// //   const [filterdata, setFilterdata] = useState();
// //   const filterRef = useRef(null);
// //   const [inventoryfilterdata, setInventoryfilterdata] = useState({
// //     SKU: [],
// //     price: [filterdata?.Price?.min, filterdata?.Price?.max],
// //     item: [],
// //     metal: [],
// //     stone: [],
// //     size: [],
// //     collection: [],
// //     location: [],
// //     status: [],
// //   });
// //   useEffect(() => {
// //     function handleClickOutside(event) {
// //       if (
// //         stockTakeFliterisOpen &&
// //         filterRef.current &&
// //         !filterRef.current.contains(event.target)
// //       ) {
// //         setStockTakeFliterIsOpen(false);
// //       }
// //     }

// //     document.addEventListener("mousedown", handleClickOutside);

// //     return () => {
// //       document.removeEventListener("mousedown", handleClickOutside);
// //     };
// //   }, [stockTakeFliterisOpen]);

// //   const callfilters = (event, label) => {
// //     let alldata = { ...inventoryfilterdata };
// //     if (label === "Item") {
// //       let itemdata = [...alldata?.item];
// //       if (event.target.checked) {
// //         itemdata.push(event.target.value);
// //         alldata.item = itemdata;
// //       } else {
// //         alldata.item = itemdata.filter((item) => item !== event.target.value);
// //       }
// //     } else if (label === "metal") {
// //       let metaldata = [...alldata?.metal];
// //       if (event.target.checked) {
// //         metaldata.push(event.target.value);
// //         alldata.metal = metaldata;
// //       } else {
// //         alldata.metal = metaldata.filter(
// //           (metal) => metal !== event.target.value,
// //         );
// //       }
// //     } else if (label === "stone") {
// //       let metaldata = [...alldata?.stone];
// //       if (event.target.checked) {
// //         metaldata.push(event.target.value);
// //         alldata.stone = metaldata;
// //       } else {
// //         alldata.stone = metaldata.filter(
// //           (stone) => stone !== event.target.value,
// //         );
// //       }
// //     } else if (label === "size") {
// //       const sizedata = [...alldata.size];
// //       if (event.target.checked) {
// //         sizedata.push(event.target.value);
// //         alldata.size = sizedata;
// //       } else {
// //         alldata.size = sizedata.filter((size) => size !== event.target.value);
// //       }
// //     } else if (label === "status") {
// //       const statusdata = [...alldata.status];
// //       if (event.target.checked) {
// //         statusdata.push(event.target.value);
// //         alldata.status = statusdata;
// //       } else {
// //         alldata.status = statusdata.filter(
// //           (status) => status !== event.target.value,
// //         );
// //       }
// //     } else if (label === "collection") {
// //       const Collectiondata = [...alldata.collection];
// //       if (event.target.checked) {
// //         Collectiondata.push(event.target.value);
// //         alldata.collection = Collectiondata;
// //       } else {
// //         alldata.collection = Collectiondata.filter(
// //           (collection) => collection !== event.target.value,
// //         );
// //       }
// //       // } else if (label === "location") {
// //       //     const locationdata = [...alldata.location];
// //       //     if (event.target.checked) {
// //       //         locationdata.push(event.target.value);
// //       //         alldata.location = locationdata
// //       //     } else {
// //       //         alldata.location = locationdata.filter((location) => location !== event.target.value)
// //       //     }
// //     } else if (label === "location") {
// //       let locationdata = [...alldata.location];

// //       if (event.target.checked) {
// //         locationdata.push(event.target.value);
// //       } else {
// //         locationdata = locationdata.filter(
// //           (location) => location !== event.target.value,
// //         );
// //       }

// //       alldata.location = locationdata;

// //       if (locationdata.length === 0) {
// //         setLocationFilter(filterdata.location);
// //       } else {
// //         setLocationFilter(
// //           filterdata.location.filter((loc) => locationdata.includes(loc._id)),
// //         );
// //       }
// //     }
// //     setInventoryfilterdata(alldata);
// //   };
// //   const selectallfilter = (labels, selectStatus) => {
// //     let alldata = { ...inventoryfilterdata };
// //     const labelMapping = {
// //       item: "_id",
// //       metal: "_id",
// //       stone: "_id",
// //       size: "_id",
// //       status: "value",
// //       collection: "_id",
// //       location: "_id",
// //     };
// //     const labelKey = labels.toLowerCase();
// //     const dataKey = labelMapping[labelKey];
// //     if (selectStatus === "select") {
// //       alldata[labelKey] = Object.values(filterdata?.[labelKey])
// //         .flat()
// //         .filter((item) => item[dataKey])
// //         .map((item) => item[dataKey]);
// //     } else {
// //       alldata[labelKey] = [];
// //     }
// //     if (labelKey === "location") {
// //       if (selectStatus === "select") {
// //         setLocationFilter(filterdata.location);
// //       } else {
// //         setLocationFilter(filterdata.location);
// //       }
// //     }
// //     setInventoryfilterdata(alldata);
// //   };

// //   const GetFilters = async () => {
// //     try {
// //       const postdata = {
// //         custom_filter_enable: custom_filter_enable ? true : false,
// //       };
// //       let res = await _Api(postdata, `api/v1/Inventory/my/filter`);
// //       if (res?.code === 200) {
// //         setFilterdata(res?.data);
// //         setLocationFilter(res?.data?.location);
// //         setInventoryfilterdata((prevState) => ({
// //           ...prevState,
// //           price: [res?.data?.Price?.min, res?.data?.Price?.max],
// //         }));
// //       }
// //     } catch (err) {
// //       console.log(err, "err");
// //     }
// //   };
// //   useEffect(() => {
// //     GetFilters();
// //     // eslint-disable-next-line
// //   }, []);

// //   const clearall = () => {
// //     let get = document.getElementsByName("clear");
// //     for (let i = 0; i < get.length; i++) {
// //       get[i].checked = false;
// //     }
// //     setInventoryfilterdata({
// //       SKU: [],
// //       price: [filterdata?.Price?.min, filterdata?.Price?.max],
// //       item: [],
// //       metal: [],
// //       stone: [],
// //       size: [],
// //       collection: [],
// //       location: [],
// //       status: [],
// //     });
// //     setStockTakeFliterIsOpen(!stockTakeFliterisOpen);
// //   };

// //   return (
// //     <>
// //       {stockTakeFliterisOpen && (
// //         <div
// //           className="dropdown-modal-content new-stock-take-scan-filter"
// //           id="filterinventory"
// //           ref={filterRef}
// //         >
// //           <div className="modal-content">
// //             <div className="modal-header">
// //               <p
// //                 className="stock-scan-filter-title"
// //                 onClick={() => {
// //                   setStockTakeFliterIsOpen(!stockTakeFliterisOpen);
// //                 }}
// //               >
// //                 {t("Filters")}
// //               </p>

// //               <button
// //                 type="button"
// //                 className="stock-scan-filter-clear-all"
// //                 onClick={(e) => {
// //                   clearall();
// //                 }}
// //               >
// //                 {t("Clear filters")}
// //               </button>
// //             </div>
// //             <div className="modal-body">
// //               {filterdata?.item?.length ? (
// //                 <div className="filter-customer-modal-single-box">
// //                   <div className="d-flex align-items-center justify-space-between row-one-wrap">
// //                     <div className="d-flex justify-content-between align-items-center w-100">
// //                       <label>{t("Item")}</label>
// //                       {filterdata?.item?.length ===
// //                       inventoryfilterdata?.item?.length ? (
// //                         <span
// //                           className="me-3 dis cursor-pointer d-inline-block graythemecolor"
// //                           style={{ fontSize: "15px" }}
// //                           onClick={() => selectallfilter("item", "clear")}
// //                         >
// //                           {t("Clear")}
// //                         </span>
// //                       ) : (
// //                         <span
// //                           className="select-all-filter-btn"
// //                           style={{ fontSize: "15px" }}
// //                           onClick={() => selectallfilter("item", "select")}
// //                         >
// //                           {t("select all")}
// //                         </span>
// //                       )}
// //                     </div>
// //                   </div>

// //                   <div className="d-flex flex-wrap filter-customer-modal-alpha filter-customer-modal-label-row ">
// //                     {filterdata?.item?.map((result, key) => {
// //                       return (
// //                         <div className="com-label-select" key={key}>
// //                           <input
// //                             className=""
// //                             type="checkbox"
// //                             id={result?._id}
// //                             value={result?._id}
// //                             checked={inventoryfilterdata.item.includes(
// //                               result?._id,
// //                             )}
// //                             name="clear"
// //                             onClick={(e) => callfilters(e, "Item")}
// //                             readOnly
// //                           />
// //                           <label
// //                             className="filter-btn-new-stock-take-scan"
// //                             htmlFor={result?._id}
// //                           >
// //                             {result?.name}
// //                           </label>
// //                         </div>
// //                       );
// //                     })}
// //                   </div>
// //                 </div>
// //               ) : (
// //                 ""
// //               )}
// //               {filterdata?.collection?.length ? (
// //                 <div className="filter-customer-modal-single-box">
// //                   <div className="d-flex align-items-center justify-space-between fw-semibold  row-one-wrap">
// //                     <div className="d-flex justify-content-between align-items-center w-100">
// //                       <label>{t("Collection")}</label>
// //                       {filterdata?.collection?.length ===
// //                       inventoryfilterdata?.collection?.length ? (
// //                         <span
// //                           className="me-3 dis cursor-pointer d-inline-block graythemecolor"
// //                           style={{ fontSize: "15px" }}
// //                           onClick={() => selectallfilter("collection", "clear")}
// //                         >
// //                           {t("Clear")}
// //                         </span>
// //                       ) : (
// //                         <span
// //                           className="select-all-filter-btn"
// //                           style={{ fontSize: "15px" }}
// //                           onClick={() =>
// //                             selectallfilter("collection", "select")
// //                           }
// //                         >
// //                           {t("select all")}
// //                         </span>
// //                       )}
// //                     </div>
// //                   </div>
// //                   <div className="d-flex flex-wrap filter-customer-modal-alpha filter-customer-modal-label-row ">
// //                     {filterdata?.collection?.map((result, key) => {
// //                       return (
// //                         <div className="com-label-select" key={key}>
// //                           <input
// //                             className=""
// //                             type="checkbox"
// //                             name="clear"
// //                             id={result?._id}
// //                             value={result?._id}
// //                             onClick={(e) => callfilters(e, "collection")}
// //                             checked={inventoryfilterdata.collection.includes(
// //                               result?._id,
// //                             )}
// //                             readOnly
// //                           />
// //                           <label
// //                             className="filter-btn-new-stock-take-scan"
// //                             htmlFor={result?._id}
// //                           >
// //                             {result?.name}
// //                           </label>
// //                         </div>
// //                       );
// //                     })}
// //                   </div>
// //                 </div>
// //               ) : (
// //                 ""
// //               )}
// //               {filterdata?.metal?.length ? (
// //                 <div className="filter-customer-modal-single-box">
// //                   <div className="d-flex align-items-center justify-space-between fw-semibold row-one-wrap">
// //                     <div className="d-flex justify-content-between align-items-center w-100">
// //                       <label>{t("Metal")}</label>
// //                       {filterdata?.metal?.length ===
// //                       inventoryfilterdata?.metal?.length ? (
// //                         <span
// //                           className="me-3 dis cursor-pointer d-inline-block graythemecolor"
// //                           style={{ fontSize: "15px" }}
// //                           onClick={() => selectallfilter("metal", "clear")}
// //                         >
// //                           {t("Clear")}
// //                         </span>
// //                       ) : (
// //                         <span
// //                           className="select-all-filter-btn"
// //                           style={{ fontSize: "15px" }}
// //                           onClick={() => selectallfilter("metal", "select")}
// //                         >
// //                           {t("select all")}
// //                         </span>
// //                       )}
// //                     </div>
// //                   </div>
// //                   <div className="d-flex flex-wrap filter-customer-modal-alpha filter-customer-modal-label-row ">
// //                     {filterdata?.metal?.map((result, key) => {
// //                       return (
// //                         <div className="com-label-select" key={key}>
// //                           <input
// //                             className=""
// //                             type="checkbox"
// //                             id={result?._id}
// //                             value={result?._id}
// //                             name="clear"
// //                             checked={inventoryfilterdata.metal.includes(
// //                               result?._id,
// //                             )}
// //                             onClick={(e) => callfilters(e, "metal")}
// //                             readOnly
// //                           />
// //                           <label
// //                             className="filter-btn-new-stock-take-scan"
// //                             htmlFor={result?._id}
// //                           >
// //                             {result?.name}
// //                           </label>
// //                         </div>
// //                       );
// //                     })}
// //                   </div>
// //                 </div>
// //               ) : (
// //                 ""
// //               )}
// //               {filterdata?.stone?.length ? (
// //                 <div className="filter-customer-modal-single-box">
// //                   <div className="d-flex align-items-center justify-space-between fw-semibold row-one-wrap">
// //                     <div className="d-flex justify-content-between align-items-center w-100">
// //                       <label>{t("Stone")}</label>
// //                       {filterdata?.stone?.length ===
// //                       inventoryfilterdata?.stone?.length ? (
// //                         <span
// //                           className="me-3 dis cursor-pointer d-inline-block graythemecolor"
// //                           style={{ fontSize: "15px" }}
// //                           onClick={() => selectallfilter("stone", "clear")}
// //                         >
// //                           {t("Clear")}
// //                         </span>
// //                       ) : (
// //                         <span
// //                           className="select-all-filter-btn"
// //                           style={{ fontSize: "15px" }}
// //                           onClick={() => selectallfilter("stone", "select")}
// //                         >
// //                           {t("select all")}
// //                         </span>
// //                       )}
// //                     </div>
// //                   </div>

// //                   <div className="d-flex flex-wrap filter-customer-modal-alpha filter-customer-modal-label-row ">
// //                     {filterdata?.stone?.map((result, key) => {
// //                       return (
// //                         <div className="com-label-select" key={key}>
// //                           <input
// //                             className=""
// //                             type="checkbox"
// //                             id={result?._id}
// //                             value={result?._id}
// //                             name="clear"
// //                             checked={inventoryfilterdata.stone.includes(
// //                               result?._id,
// //                             )}
// //                             onClick={(e) => callfilters(e, "stone")}
// //                             readOnly
// //                           />
// //                           <label
// //                             className="filter-btn-new-stock-take-scan"
// //                             htmlFor={result?._id}
// //                           >
// //                             {result?.name}
// //                           </label>
// //                         </div>
// //                       );
// //                     })}
// //                   </div>
// //                 </div>
// //               ) : (
// //                 ""
// //               )}
// //               {filterdata?.size?.length ? (
// //                 <div className="filter-customer-modal-single-box">
// //                   <div className="d-flex align-items-center justify-space-between fw-semibold row-one-wrap">
// //                     <div className="d-flex justify-content-between align-items-center w-100">
// //                       <label>{t("Size")}</label>
// //                       {filterdata?.size?.length ===
// //                       inventoryfilterdata?.size?.length ? (
// //                         <span
// //                           className="me-3 dis cursor-pointer d-inline-block graythemecolor"
// //                           style={{ fontSize: "15px" }}
// //                           onClick={() => selectallfilter("size", "clear")}
// //                         >
// //                           {t("Clear")}
// //                         </span>
// //                       ) : (
// //                         <span
// //                           className="select-all-filter-btn"
// //                           style={{ fontSize: "15px" }}
// //                           onClick={() => selectallfilter("size", "select")}
// //                         >
// //                           {t("select all")}
// //                         </span>
// //                       )}
// //                     </div>
// //                   </div>
// //                   <div className="d-flex flex-wrap filter-customer-modal-alpha filter-customer-modal-label-row ">
// //                     {filterdata?.size?.map((result, key) => {
// //                       return (
// //                         <div className="com-label-select" key={key}>
// //                           <input
// //                             className=""
// //                             type="checkbox"
// //                             id={result?._id}
// //                             name="clear"
// //                             value={result?._id}
// //                             checked={inventoryfilterdata.size.includes(
// //                               result?._id,
// //                             )}
// //                             onClick={(e) => callfilters(e, "size")}
// //                             readOnly
// //                           />
// //                           <label
// //                             className="filter-btn-new-stock-take-scan"
// //                             htmlFor={result?._id}
// //                           >
// //                             {result?.name}
// //                           </label>
// //                         </div>
// //                       );
// //                     })}
// //                   </div>
// //                 </div>
// //               ) : (
// //                 ""
// //               )}
// //               {filterdata?.location?.length ? (
// //                 <div className="filter-customer-modal-single-box">
// //                   <div className="d-flex align-items-center justify-space-between fw-semibold row-one-wrap">
// //                     <div className="d-flex justify-content-between align-items-center w-100">
// //                       <label>{t("Location")}</label>
// //                       {filterdata?.location?.length ===
// //                       inventoryfilterdata?.location?.length ? (
// //                         <span
// //                           className="me-3 dis cursor-pointer d-inline-block graythemecolor"
// //                           style={{ fontSize: "15px" }}
// //                           onClick={() => selectallfilter("location", "clear")}
// //                         >
// //                           {t("Clear")}
// //                         </span>
// //                       ) : (
// //                         <span
// //                           className="select-all-filter-btn"
// //                           style={{ fontSize: "15px" }}
// //                           onClick={() => selectallfilter("location", "select")}
// //                         >
// //                           {t("select all")}
// //                         </span>
// //                       )}
// //                     </div>
// //                   </div>

// //                   <div className="d-flex flex-wrap filter-customer-modal-alpha filter-customer-modal-label-row ">
// //                     {filterdata?.location?.map((result, key) => {
// //                       return (
// //                         <div className="com-label-select" key={key}>
// //                           <input
// //                             className=""
// //                             type="checkbox"
// //                             name="clear"
// //                             id={result?._id}
// //                             value={result?._id}
// //                             onClick={(e) => callfilters(e, "location")}
// //                             checked={inventoryfilterdata.location.includes(
// //                               result?._id,
// //                             )}
// //                             readOnly
// //                           />
// //                           <label
// //                             className="filter-btn-new-stock-take-scan"
// //                             htmlFor={result?._id}
// //                           >
// //                             {result?.name}
// //                           </label>
// //                         </div>
// //                       );
// //                     })}
// //                   </div>
// //                 </div>
// //               ) : (
// //                 ""
// //               )}
// //               {filterdata?.status?.length ? (
// //                 <div className="filter-customer-modal-single-box">
// //                   <div className="d-flex align-items-center justify-space-between fw-semibold row-one-wrap">
// //                     <div className="d-flex justify-content-between align-items-center w-100">
// //                       <label>{t("Status")}</label>
// //                       {filterdata?.status?.length ===
// //                       inventoryfilterdata?.status?.length ? (
// //                         <span
// //                           className="me-3 dis cursor-pointer d-inline-block graythemecolor"
// //                           style={{ fontSize: "15px" }}
// //                           onClick={() => selectallfilter("status", "clear")}
// //                         >
// //                           {t("Clear")}
// //                         </span>
// //                       ) : (
// //                         <span
// //                           className="select-all-filter-btn"
// //                           style={{ fontSize: "15px" }}
// //                           onClick={() => selectallfilter("status", "select")}
// //                         >
// //                           {t("select all")}
// //                         </span>
// //                       )}
// //                     </div>
// //                   </div>

// //                   <div className="d-flex flex-wrap filter-customer-modal-alpha filter-customer-modal-label-row ">
// //                     {filterdata?.status?.map((result, key) => {
// //                       return (
// //                         <div className="com-label-select" key={key}>
// //                           <input
// //                             className=""
// //                             type="checkbox"
// //                             name="clear"
// //                             id={result?.value}
// //                             value={result?.value}
// //                             onClick={(e) => callfilters(e, "status")}
// //                             checked={inventoryfilterdata.status.includes(
// //                               result?.value,
// //                             )}
// //                             readOnly
// //                           />
// //                           <label
// //                             className="text-center bg-f2 py-2 rounded-5 px-3 w-auto"
// //                             htmlFor={result?.value}
// //                           >
// //                             {result?.name}
// //                           </label>
// //                         </div>
// //                       );
// //                     })}
// //                   </div>
// //                 </div>
// //               ) : (
// //                 ""
// //               )}
// //               {custom_filter_enable ? (
// //                 <div className="filter-customer-modal-single-box">
// //                   <div className="d-flex align-items-center justify-space-between fw-semibold row-one-wrap">
// //                     <div className="d-flex justify-content-between align-items-center w-100">
// //                       <label>{t("Price")}</label>
// //                     </div>
// //                   </div>

// //                   <div className="filter-customer-modal-alpha filter-customer-modal-label-row">
// //                     <div className="range-area mt-0">
// //                       <Slider
// //                         range
// //                         min={
// //                           filterdata?.Price?.min ? filterdata?.Price?.min : 0
// //                         }
// //                         max={
// //                           filterdata?.Price?.max ? filterdata?.Price?.max : 1000
// //                         }
// //                         value={inventoryfilterdata?.price}
// //                         onChange={(e) =>
// //                           setInventoryfilterdata((prevState) => ({
// //                             ...prevState,
// //                             price: e,
// //                           }))
// //                         }
// //                       />
// //                       <div className="range-area-num d-flex justify-content-between">
// //                         <div className="range-area-num-single">
// //                           <span className="range-area-num-unit">
// //                             {inventoryfilterdata?.price[0]}
// //                           </span>
// //                         </div>
// //                         <div className="range-area-num-single">
// //                           <span className="range-area-num-unit">
// //                             {inventoryfilterdata?.price[1]}
// //                           </span>
// //                         </div>
// //                       </div>
// //                     </div>
// //                   </div>
// //                 </div>
// //               ) : (
// //                 ""
// //               )}
// //             </div>
// //             <div className="modal-footer">
// //               <button
// //                 type="button"
// //                 className="com-btn"
// //                 data-bs-dismiss="modal"
// //                 onClick={() => {
// //                   submitfiltter(1, limit, inventoryfilterdata);
// //                 }}
// //               >
// //                 {t("Apply Filters")}
// //               </button>
// //             </div>
// //           </div>
// //         </div>
// //       )}
// //     </>
// //   );
// // };

// // export default NewFilterModal;

// import React, { useEffect, useRef, useState } from "react";
// import "datatables.net-fixedcolumns";
// import { useTranslation } from "react-i18next";
// import Slider from "rc-slider";

// import { _Api } from "../../components/api/_call";
// import "./NewFilterModal.scss";

// const ChevronIcon = ({ open }) => (
//   <svg
//     className={open ? "filter-chevron open" : "filter-chevron"}
//     width="10"
//     height="6"
//     viewBox="0 0 10 6"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M1 1L5 5L9 1"
//       stroke="#585858"
//       strokeWidth="1.3"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//   </svg>
// );

// const NewFilterModal = (props) => {
//   const {
//     submitfiltter,
//     limit,
//     custom_filter_enable,
//     stockTakeFliterisOpen,
//     setStockTakeFliterIsOpen,
//     setLocationFilter,
//   } = props;
//   const { t } = useTranslation();
//   const [filterdata, setFilterdata] = useState();
//   const filterRef = useRef(null);
//   const [inventoryfilterdata, setInventoryfilterdata] = useState({
//     SKU: [],
//     price: [filterdata?.Price?.min, filterdata?.Price?.max],
//     item: [],
//     metal: [],
//     stone: [],
//     size: [],
//     collection: [],
//     location: [],
//     status: [],
//   });

//   // Accordion open/closed state for each filter section. All start collapsed.
//   const [openSections, setOpenSections] = useState({
//     location: false,
//     item: false,
//     collection: false,
//     metal: false,
//     stone: false,
//     size: false,
//     status: false,
//     price: false,
//   });

//   const toggleSection = (key) => {
//     setOpenSections((prev) => ({ ...prev, [key]: !prev[key] }));
//   };

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (
//         stockTakeFliterisOpen &&
//         filterRef.current &&
//         !filterRef.current.contains(event.target)
//       ) {
//         setStockTakeFliterIsOpen(false);
//       }
//     }

//     document.addEventListener("mousedown", handleClickOutside);

//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, [stockTakeFliterisOpen]);

//   const callfilters = (event, label) => {
//     let alldata = { ...inventoryfilterdata };
//     if (label === "Item") {
//       let itemdata = [...alldata?.item];
//       if (event.target.checked) {
//         itemdata.push(event.target.value);
//         alldata.item = itemdata;
//       } else {
//         alldata.item = itemdata.filter((item) => item !== event.target.value);
//       }
//     } else if (label === "metal") {
//       let metaldata = [...alldata?.metal];
//       if (event.target.checked) {
//         metaldata.push(event.target.value);
//         alldata.metal = metaldata;
//       } else {
//         alldata.metal = metaldata.filter(
//           (metal) => metal !== event.target.value,
//         );
//       }
//     } else if (label === "stone") {
//       let metaldata = [...alldata?.stone];
//       if (event.target.checked) {
//         metaldata.push(event.target.value);
//         alldata.stone = metaldata;
//       } else {
//         alldata.stone = metaldata.filter(
//           (stone) => stone !== event.target.value,
//         );
//       }
//     } else if (label === "size") {
//       const sizedata = [...alldata.size];
//       if (event.target.checked) {
//         sizedata.push(event.target.value);
//         alldata.size = sizedata;
//       } else {
//         alldata.size = sizedata.filter((size) => size !== event.target.value);
//       }
//     } else if (label === "status") {
//       const statusdata = [...alldata.status];
//       if (event.target.checked) {
//         statusdata.push(event.target.value);
//         alldata.status = statusdata;
//       } else {
//         alldata.status = statusdata.filter(
//           (status) => status !== event.target.value,
//         );
//       }
//     } else if (label === "collection") {
//       const Collectiondata = [...alldata.collection];
//       if (event.target.checked) {
//         Collectiondata.push(event.target.value);
//         alldata.collection = Collectiondata;
//       } else {
//         alldata.collection = Collectiondata.filter(
//           (collection) => collection !== event.target.value,
//         );
//       }
//     } else if (label === "location") {
//       let locationdata = [...alldata.location];

//       if (event.target.checked) {
//         locationdata.push(event.target.value);
//       } else {
//         locationdata = locationdata.filter(
//           (location) => location !== event.target.value,
//         );
//       }

//       alldata.location = locationdata;

//       if (locationdata.length === 0) {
//         setLocationFilter(filterdata.location);
//       } else {
//         setLocationFilter(
//           filterdata.location.filter((loc) => locationdata.includes(loc._id)),
//         );
//       }
//     }
//     setInventoryfilterdata(alldata);
//   };

//   const selectallfilter = (labels, selectStatus) => {
//     let alldata = { ...inventoryfilterdata };
//     const labelMapping = {
//       item: "_id",
//       metal: "_id",
//       stone: "_id",
//       size: "_id",
//       status: "value",
//       collection: "_id",
//       location: "_id",
//     };
//     const labelKey = labels.toLowerCase();
//     const dataKey = labelMapping[labelKey];
//     if (selectStatus === "select") {
//       alldata[labelKey] = Object.values(filterdata?.[labelKey])
//         .flat()
//         .filter((item) => item[dataKey])
//         .map((item) => item[dataKey]);
//     } else {
//       alldata[labelKey] = [];
//     }
//     if (labelKey === "location") {
//       if (selectStatus === "select") {
//         setLocationFilter(filterdata.location);
//       } else {
//         setLocationFilter(filterdata.location);
//       }
//     }
//     setInventoryfilterdata(alldata);
//   };

//   const GetFilters = async () => {
//     try {
//       const postdata = {
//         custom_filter_enable: custom_filter_enable ? true : false,
//       };
//       let res = await _Api(postdata, `api/v1/Inventory/my/filter`);
//       if (res?.code === 200) {
//         setFilterdata(res?.data);
//         setLocationFilter(res?.data?.location);
//         setInventoryfilterdata((prevState) => ({
//           ...prevState,
//           price: [res?.data?.Price?.min, res?.data?.Price?.max],
//         }));
//       }
//     } catch (err) {
//       console.log(err, "err");
//     }
//   };
//   useEffect(() => {
//     GetFilters();
//     // eslint-disable-next-line
//   }, []);

//   const clearall = () => {
//     let get = document.getElementsByName("clear");
//     for (let i = 0; i < get.length; i++) {
//       get[i].checked = false;
//     }
//     setInventoryfilterdata({
//       SKU: [],
//       price: [filterdata?.Price?.min, filterdata?.Price?.max],
//       item: [],
//       metal: [],
//       stone: [],
//       size: [],
//       collection: [],
//       location: [],
//       status: [],
//     });
//     setStockTakeFliterIsOpen(!stockTakeFliterisOpen);
//   };

//   // Reusable header row: label on the left, "select all / clear" (only when
//   // expanded) + chevron on the right. Clicking anywhere on the row toggles
//   // open/close; clicking select-all/clear stops that from also firing.
//   const renderSectionHeader = ({ sectionKey, title, total, selected }) => (
//     <div
//       className="d-flex align-items-center justify-space-between row-one-wrap filter-section-header"
//       onClick={() => toggleSection(sectionKey)}
//     >
//       <div className="d-flex justify-content-between align-items-center w-100">
//         <label>{t(title)}</label>
//         <div className="filter-section-header-right">
//           {openSections[sectionKey] &&
//             (total === selected ? (
//               <span
//                 className="me-3 dis cursor-pointer d-inline-block graythemecolor"
//                 style={{ fontSize: "15px" }}
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   selectallfilter(sectionKey, "clear");
//                 }}
//               >
//                 {t("Clear")}
//               </span>
//             ) : (
//               <span
//                 className="select-all-filter-btn"
//                 style={{ fontSize: "15px" }}
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   selectallfilter(sectionKey, "select");
//                 }}
//               >
//                 {t("select all")}
//               </span>
//             ))}
//           <ChevronIcon open={openSections[sectionKey]} />
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <>
//       {stockTakeFliterisOpen && (
//         <div
//           className="dropdown-modal-content new-stock-take-scan-filter"
//           id="filterinventory"
//           ref={filterRef}
//         >
//           <div className="modal-content">
//             <div className="modal-header">
//               <p
//                 className="stock-scan-filter-title"
//                 onClick={() => {
//                   setStockTakeFliterIsOpen(!stockTakeFliterisOpen);
//                 }}
//               >
//                 {t("Filters")}
//               </p>

//               <button
//                 type="button"
//                 className="stock-scan-filter-clear-all"
//                 onClick={(e) => {
//                   clearall();
//                 }}
//               >
//                 {t("Clear filters")}
//               </button>
//             </div>
//             <div className="modal-body">
//               {filterdata?.location?.length ? (
//                 <div className="filter-customer-modal-single-box">
//                   {renderSectionHeader({
//                     sectionKey: "location",
//                     title: "Location",
//                     total: filterdata?.location?.length,
//                     selected: inventoryfilterdata?.location?.length,
//                   })}

//                   {openSections.location && (
//                     <div className="d-flex flex-wrap filter-customer-modal-alpha filter-customer-modal-label-row ">
//                       {filterdata?.location?.map((result, key) => {
//                         return (
//                           <div className="com-label-select" key={key}>
//                             <input
//                               className=""
//                               type="checkbox"
//                               name="clear"
//                               id={result?._id}
//                               value={result?._id}
//                               onClick={(e) => callfilters(e, "location")}
//                               checked={inventoryfilterdata.location.includes(
//                                 result?._id,
//                               )}
//                               readOnly
//                             />
//                             <label
//                               className="filter-btn-new-stock-take-scan"
//                               htmlFor={result?._id}
//                             >
//                               {result?.name}
//                             </label>
//                           </div>
//                         );
//                       })}
//                     </div>
//                   )}
//                 </div>
//               ) : (
//                 ""
//               )}

//               {filterdata?.item?.length ? (
//                 <div className="filter-customer-modal-single-box">
//                   {renderSectionHeader({
//                     sectionKey: "item",
//                     title: "Item",
//                     total: filterdata?.item?.length,
//                     selected: inventoryfilterdata?.item?.length,
//                   })}

//                   {openSections.item && (
//                     <div className="d-flex flex-wrap filter-customer-modal-alpha filter-customer-modal-label-row ">
//                       {filterdata?.item?.map((result, key) => {
//                         return (
//                           <div className="com-label-select" key={key}>
//                             <input
//                               className=""
//                               type="checkbox"
//                               id={result?._id}
//                               value={result?._id}
//                               checked={inventoryfilterdata.item.includes(
//                                 result?._id,
//                               )}
//                               name="clear"
//                               onClick={(e) => callfilters(e, "Item")}
//                               readOnly
//                             />
//                             <label
//                               className="filter-btn-new-stock-take-scan"
//                               htmlFor={result?._id}
//                             >
//                               {result?.name}
//                             </label>
//                           </div>
//                         );
//                       })}
//                     </div>
//                   )}
//                 </div>
//               ) : (
//                 ""
//               )}

//               {filterdata?.collection?.length ? (
//                 <div className="filter-customer-modal-single-box">
//                   {renderSectionHeader({
//                     sectionKey: "collection",
//                     title: "Collection",
//                     total: filterdata?.collection?.length,
//                     selected: inventoryfilterdata?.collection?.length,
//                   })}

//                   {openSections.collection && (
//                     <div className="d-flex flex-wrap filter-customer-modal-alpha filter-customer-modal-label-row ">
//                       {filterdata?.collection?.map((result, key) => {
//                         return (
//                           <div className="com-label-select" key={key}>
//                             <input
//                               className=""
//                               type="checkbox"
//                               name="clear"
//                               id={result?._id}
//                               value={result?._id}
//                               onClick={(e) => callfilters(e, "collection")}
//                               checked={inventoryfilterdata.collection.includes(
//                                 result?._id,
//                               )}
//                               readOnly
//                             />
//                             <label
//                               className="filter-btn-new-stock-take-scan"
//                               htmlFor={result?._id}
//                             >
//                               {result?.name}
//                             </label>
//                           </div>
//                         );
//                       })}
//                     </div>
//                   )}
//                 </div>
//               ) : (
//                 ""
//               )}

//               {filterdata?.metal?.length ? (
//                 <div className="filter-customer-modal-single-box">
//                   {renderSectionHeader({
//                     sectionKey: "metal",
//                     title: "Metal",
//                     total: filterdata?.metal?.length,
//                     selected: inventoryfilterdata?.metal?.length,
//                   })}

//                   {openSections.metal && (
//                     <div className="d-flex flex-wrap filter-customer-modal-alpha filter-customer-modal-label-row ">
//                       {filterdata?.metal?.map((result, key) => {
//                         return (
//                           <div className="com-label-select" key={key}>
//                             <input
//                               className=""
//                               type="checkbox"
//                               id={result?._id}
//                               value={result?._id}
//                               name="clear"
//                               checked={inventoryfilterdata.metal.includes(
//                                 result?._id,
//                               )}
//                               onClick={(e) => callfilters(e, "metal")}
//                               readOnly
//                             />
//                             <label
//                               className="filter-btn-new-stock-take-scan"
//                               htmlFor={result?._id}
//                             >
//                               {result?.name}
//                             </label>
//                           </div>
//                         );
//                       })}
//                     </div>
//                   )}
//                 </div>
//               ) : (
//                 ""
//               )}

//               {filterdata?.stone?.length ? (
//                 <div className="filter-customer-modal-single-box">
//                   {renderSectionHeader({
//                     sectionKey: "stone",
//                     title: "Stone",
//                     total: filterdata?.stone?.length,
//                     selected: inventoryfilterdata?.stone?.length,
//                   })}

//                   {openSections.stone && (
//                     <div className="d-flex flex-wrap filter-customer-modal-alpha filter-customer-modal-label-row ">
//                       {filterdata?.stone?.map((result, key) => {
//                         return (
//                           <div className="com-label-select" key={key}>
//                             <input
//                               className=""
//                               type="checkbox"
//                               id={result?._id}
//                               value={result?._id}
//                               name="clear"
//                               checked={inventoryfilterdata.stone.includes(
//                                 result?._id,
//                               )}
//                               onClick={(e) => callfilters(e, "stone")}
//                               readOnly
//                             />
//                             <label
//                               className="filter-btn-new-stock-take-scan"
//                               htmlFor={result?._id}
//                             >
//                               {result?.name}
//                             </label>
//                           </div>
//                         );
//                       })}
//                     </div>
//                   )}
//                 </div>
//               ) : (
//                 ""
//               )}

//               {filterdata?.size?.length ? (
//                 <div className="filter-customer-modal-single-box">
//                   {renderSectionHeader({
//                     sectionKey: "size",
//                     title: "Size",
//                     total: filterdata?.size?.length,
//                     selected: inventoryfilterdata?.size?.length,
//                   })}

//                   {openSections.size && (
//                     <div className="d-flex flex-wrap filter-customer-modal-alpha filter-customer-modal-label-row ">
//                       {filterdata?.size?.map((result, key) => {
//                         return (
//                           <div className="com-label-select" key={key}>
//                             <input
//                               className=""
//                               type="checkbox"
//                               id={result?._id}
//                               name="clear"
//                               value={result?._id}
//                               checked={inventoryfilterdata.size.includes(
//                                 result?._id,
//                               )}
//                               onClick={(e) => callfilters(e, "size")}
//                               readOnly
//                             />
//                             <label
//                               className="filter-btn-new-stock-take-scan"
//                               htmlFor={result?._id}
//                             >
//                               {result?.name}
//                             </label>
//                           </div>
//                         );
//                       })}
//                     </div>
//                   )}
//                 </div>
//               ) : (
//                 ""
//               )}

//               {filterdata?.status?.length ? (
//                 <div className="filter-customer-modal-single-box">
//                   {renderSectionHeader({
//                     sectionKey: "status",
//                     title: "Status",
//                     total: filterdata?.status?.length,
//                     selected: inventoryfilterdata?.status?.length,
//                   })}

//                   {openSections.status && (
//                     <div className="d-flex flex-wrap filter-customer-modal-alpha filter-customer-modal-label-row ">
//                       {filterdata?.status?.map((result, key) => {
//                         return (
//                           <div className="com-label-select" key={key}>
//                             <input
//                               className=""
//                               type="checkbox"
//                               name="clear"
//                               id={result?.value}
//                               value={result?.value}
//                               onClick={(e) => callfilters(e, "status")}
//                               checked={inventoryfilterdata.status.includes(
//                                 result?.value,
//                               )}
//                               readOnly
//                             />
//                             <label
//                               className="text-center bg-f2 py-2 rounded-5 px-3 w-auto"
//                               htmlFor={result?.value}
//                             >
//                               {result?.name}
//                             </label>
//                           </div>
//                         );
//                       })}
//                     </div>
//                   )}
//                 </div>
//               ) : (
//                 ""
//               )}

//               {custom_filter_enable ? (
//                 <div className="filter-customer-modal-single-box">
//                   <div
//                     className="d-flex align-items-center justify-space-between fw-semibold row-one-wrap filter-section-header"
//                     onClick={() => toggleSection("price")}
//                   >
//                     <div className="d-flex justify-content-between align-items-center w-100">
//                       <label>{t("Price")}</label>
//                       <div className="filter-section-header-right">
//                         <ChevronIcon open={openSections.price} />
//                       </div>
//                     </div>
//                   </div>

//                   {openSections.price && (
//                     <div className="filter-customer-modal-alpha filter-customer-modal-label-row">
//                       <div className="range-area mt-0">
//                         <Slider
//                           range
//                           min={
//                             filterdata?.Price?.min
//                               ? filterdata?.Price?.min
//                               : 0
//                           }
//                           max={
//                             filterdata?.Price?.max
//                               ? filterdata?.Price?.max
//                               : 1000
//                           }
//                           value={inventoryfilterdata?.price}
//                           onChange={(e) =>
//                             setInventoryfilterdata((prevState) => ({
//                               ...prevState,
//                               price: e,
//                             }))
//                           }
//                         />
//                         <div className="range-area-num d-flex justify-content-between">
//                           <div className="range-area-num-single">
//                             <span className="range-area-num-unit">
//                               {inventoryfilterdata?.price[0]}
//                             </span>
//                           </div>
//                           <div className="range-area-num-single">
//                             <span className="range-area-num-unit">
//                               {inventoryfilterdata?.price[1]}
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               ) : (
//                 ""
//               )}
//             </div>
//             <div className="modal-footer">
//               <button
//                 type="button"
//                 className="com-btn"
//                 data-bs-dismiss="modal"
//                 onClick={() => {
//                   submitfiltter(1, limit, inventoryfilterdata);
//                 }}
//               >
//                 {t("Apply Filters")}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default NewFilterModal;

import React, { useEffect, useRef, useState } from "react";
import "datatables.net-fixedcolumns";
import { useTranslation } from "react-i18next";
import Slider from "rc-slider";

import { _Api } from "../../components/api/_call";
import "./NewFilterModal.scss";

const ChevronIcon = ({ open }) => (
  <svg
    className={open ? "filter-chevron open" : "filter-chevron"}
    width="10"
    height="6"
    viewBox="0 0 10 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 1L5 5L9 1"
      stroke="#585858"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const NewFilterModal = (props) => {
  const {
    submitfiltter,
    limit,
    custom_filter_enable,
    stockTakeFliterisOpen,
    setStockTakeFliterIsOpen,
    setLocationFilter,
  } = props;
  const { t } = useTranslation();
  const [filterdata, setFilterdata] = useState();
  const filterRef = useRef(null);
  const [inventoryfilterdata, setInventoryfilterdata] = useState({
    SKU: [],
    price: [filterdata?.Price?.min, filterdata?.Price?.max],
    item: [],
    metal: [],
    stone: [],
    size: [],
    collection: [],
    location: [],
    status: [],
  });

  // Accordion open/closed state for each filter section. All start collapsed.
  const [openSections, setOpenSections] = useState({
    location: false,
    item: false,
    collection: false,
    metal: false,
    stone: false,
    size: false,
    status: false,
    price: false,
  });

  const toggleSection = (key) => {
    setOpenSections((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        stockTakeFliterisOpen &&
        filterRef.current &&
        !filterRef.current.contains(event.target)
      ) {
        setStockTakeFliterIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [stockTakeFliterisOpen]);

  const callfilters = (event, label) => {
    let alldata = { ...inventoryfilterdata };
    if (label === "Item") {
      let itemdata = [...alldata?.item];
      if (event.target.checked) {
        itemdata.push(event.target.value);
        alldata.item = itemdata;
      } else {
        alldata.item = itemdata.filter((item) => item !== event.target.value);
      }
    } else if (label === "metal") {
      let metaldata = [...alldata?.metal];
      if (event.target.checked) {
        metaldata.push(event.target.value);
        alldata.metal = metaldata;
      } else {
        alldata.metal = metaldata.filter(
          (metal) => metal !== event.target.value,
        );
      }
    } else if (label === "stone") {
      let metaldata = [...alldata?.stone];
      if (event.target.checked) {
        metaldata.push(event.target.value);
        alldata.stone = metaldata;
      } else {
        alldata.stone = metaldata.filter(
          (stone) => stone !== event.target.value,
        );
      }
    } else if (label === "size") {
      const sizedata = [...alldata.size];
      if (event.target.checked) {
        sizedata.push(event.target.value);
        alldata.size = sizedata;
      } else {
        alldata.size = sizedata.filter((size) => size !== event.target.value);
      }
    } else if (label === "status") {
      const statusdata = [...alldata.status];
      if (event.target.checked) {
        statusdata.push(event.target.value);
        alldata.status = statusdata;
      } else {
        alldata.status = statusdata.filter(
          (status) => status !== event.target.value,
        );
      }
    } else if (label === "collection") {
      const Collectiondata = [...alldata.collection];
      if (event.target.checked) {
        Collectiondata.push(event.target.value);
        alldata.collection = Collectiondata;
      } else {
        alldata.collection = Collectiondata.filter(
          (collection) => collection !== event.target.value,
        );
      }
    } else if (label === "location") {
      let locationdata = [...alldata.location];

      if (event.target.checked) {
        locationdata.push(event.target.value);
      } else {
        locationdata = locationdata.filter(
          (location) => location !== event.target.value,
        );
      }

      alldata.location = locationdata;

      if (locationdata.length === 0) {
        setLocationFilter(filterdata.location);
      } else {
        setLocationFilter(
          filterdata.location.filter((loc) => locationdata.includes(loc._id)),
        );
      }
    }
    setInventoryfilterdata(alldata);
  };

  const selectallfilter = (labels, selectStatus) => {
    let alldata = { ...inventoryfilterdata };
    const labelMapping = {
      item: "_id",
      metal: "_id",
      stone: "_id",
      size: "_id",
      status: "value",
      collection: "_id",
      location: "_id",
    };
    const labelKey = labels.toLowerCase();
    const dataKey = labelMapping[labelKey];
    if (selectStatus === "select") {
      alldata[labelKey] = Object.values(filterdata?.[labelKey])
        .flat()
        .filter((item) => item[dataKey])
        .map((item) => item[dataKey]);
    } else {
      alldata[labelKey] = [];
    }
    if (labelKey === "location") {
      if (selectStatus === "select") {
        setLocationFilter(filterdata.location);
      } else {
        setLocationFilter(filterdata.location);
      }
    }
    setInventoryfilterdata(alldata);
  };

  const GetFilters = async () => {
    try {
      const postdata = {
        custom_filter_enable: custom_filter_enable ? true : false,
      };
      let res = await _Api(postdata, `api/v1/Inventory/my/filter`);
      if (res?.code === 200) {
        setFilterdata(res?.data);
        setLocationFilter(res?.data?.location);
        setInventoryfilterdata((prevState) => ({
          ...prevState,
          price: [res?.data?.Price?.min, res?.data?.Price?.max],
        }));
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  useEffect(() => {
    GetFilters();
    // eslint-disable-next-line
  }, []);

  const clearall = () => {
    let get = document.getElementsByName("clear");
    for (let i = 0; i < get.length; i++) {
      get[i].checked = false;
    }
    setInventoryfilterdata({
      SKU: [],
      price: [filterdata?.Price?.min, filterdata?.Price?.max],
      item: [],
      metal: [],
      stone: [],
      size: [],
      collection: [],
      location: [],
      status: [],
    });
    setStockTakeFliterIsOpen(!stockTakeFliterisOpen);
  };

  // Reusable header row: label on the left, "select all / clear" (only when
  // expanded) + chevron on the right. Clicking anywhere on the row toggles
  // open/close; clicking select-all/clear stops that from also firing.
  const renderSectionHeader = ({ sectionKey, title, total, selected }) => (
    <div
      className="d-flex align-items-center justify-space-between row-one-wrap filter-section-header"
      onClick={() => toggleSection(sectionKey)}
    >
      <div className="d-flex justify-content-between align-items-center w-100">
        <label>{t(title)}</label>
        <div className="filter-section-header-right">
          {openSections[sectionKey] &&
            (total === selected ? (
              <span
                className="me-3 dis cursor-pointer d-inline-block graythemecolor"
                style={{ fontSize: "15px" }}
                onClick={(e) => {
                  e.stopPropagation();
                  selectallfilter(sectionKey, "clear");
                }}
              >
                {t("Clear")}
              </span>
            ) : (
              <span
                className="select-all-filter-btn"
                style={{ fontSize: "15px" }}
                onClick={(e) => {
                  e.stopPropagation();
                  selectallfilter(sectionKey, "select");
                }}
              >
                {t("select all")}
              </span>
            ))}
          <ChevronIcon open={openSections[sectionKey]} />
        </div>
      </div>
    </div>
  );

  return (
    <>
      {stockTakeFliterisOpen && (
        <>
          <div
            className="stock-take-filter-sidebar-backdrop"
            onClick={() => setStockTakeFliterIsOpen(false)}
          />
          <div
            className="dropdown-modal-content new-stock-take-scan-filter stock-take-filter-sidebar"
            id="filterinventory"
            ref={filterRef}
          >
            <div className="modal-content">
              <div className="modal-header">
                <div className="stock-scan-filter-header-left">
                  <p className="stock-scan-filter-title">{t("Filters")}</p>
                </div>

                <button
                  type="button"
                  className="stock-scan-filter-clear-all"
                  onClick={() => {
                    clearall();
                    submitfiltter();
                  }}
                >
                  {t("Clear filters")}
                </button>
                <button
                  type="button"
                  className="stock-scan-filter-close-btn"
                  onClick={() => setStockTakeFliterIsOpen(false)}
                  title={t("Close")}
                  aria-label={t("Close")}
                >
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 1L1 13M1 1L13 13"
                      stroke="#A4A4A4"
                      strokeWidth="1.3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
              <div className="modal-body">
                {filterdata?.location?.length ? (
                  <div className="filter-customer-modal-single-box">
                    {renderSectionHeader({
                      sectionKey: "location",
                      title: "Location",
                      total: filterdata?.location?.length,
                      selected: inventoryfilterdata?.location?.length,
                    })}

                    {openSections.location && (
                      <div className="d-flex flex-wrap filter-customer-modal-alpha filter-customer-modal-label-row ">
                        {filterdata?.location?.map((result, key) => {
                          return (
                            <div className="com-label-select" key={key}>
                              <input
                                className=""
                                type="checkbox"
                                name="clear"
                                id={result?._id}
                                value={result?._id}
                                onClick={(e) => callfilters(e, "location")}
                                checked={inventoryfilterdata.location.includes(
                                  result?._id,
                                )}
                                readOnly
                              />
                              <label
                                className="filter-btn-new-stock-take-scan"
                                htmlFor={result?._id}
                              >
                                {result?.name}
                              </label>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                ) : (
                  ""
                )}

                {filterdata?.item?.length ? (
                  <div className="filter-customer-modal-single-box">
                    {renderSectionHeader({
                      sectionKey: "item",
                      title: "Item",
                      total: filterdata?.item?.length,
                      selected: inventoryfilterdata?.item?.length,
                    })}

                    {openSections.item && (
                      <div className="d-flex flex-wrap filter-customer-modal-alpha filter-customer-modal-label-row ">
                        {filterdata?.item?.map((result, key) => {
                          return (
                            <div className="com-label-select" key={key}>
                              <input
                                className=""
                                type="checkbox"
                                id={result?._id}
                                value={result?._id}
                                checked={inventoryfilterdata.item.includes(
                                  result?._id,
                                )}
                                name="clear"
                                onClick={(e) => callfilters(e, "Item")}
                                readOnly
                              />
                              <label
                                className="filter-btn-new-stock-take-scan"
                                htmlFor={result?._id}
                              >
                                {result?.name}
                              </label>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                ) : (
                  ""
                )}

                {filterdata?.collection?.length ? (
                  <div className="filter-customer-modal-single-box">
                    {renderSectionHeader({
                      sectionKey: "collection",
                      title: "Collection",
                      total: filterdata?.collection?.length,
                      selected: inventoryfilterdata?.collection?.length,
                    })}

                    {openSections.collection && (
                      <div className="d-flex flex-wrap filter-customer-modal-alpha filter-customer-modal-label-row ">
                        {filterdata?.collection?.map((result, key) => {
                          return (
                            <div className="com-label-select" key={key}>
                              <input
                                className=""
                                type="checkbox"
                                name="clear"
                                id={result?._id}
                                value={result?._id}
                                onClick={(e) => callfilters(e, "collection")}
                                checked={inventoryfilterdata.collection.includes(
                                  result?._id,
                                )}
                                readOnly
                              />
                              <label
                                className="filter-btn-new-stock-take-scan"
                                htmlFor={result?._id}
                              >
                                {result?.name}
                              </label>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                ) : (
                  ""
                )}

                {filterdata?.metal?.length ? (
                  <div className="filter-customer-modal-single-box">
                    {renderSectionHeader({
                      sectionKey: "metal",
                      title: "Metal",
                      total: filterdata?.metal?.length,
                      selected: inventoryfilterdata?.metal?.length,
                    })}

                    {openSections.metal && (
                      <div className="d-flex flex-wrap filter-customer-modal-alpha filter-customer-modal-label-row ">
                        {filterdata?.metal?.map((result, key) => {
                          return (
                            <div className="com-label-select" key={key}>
                              <input
                                className=""
                                type="checkbox"
                                id={result?._id}
                                value={result?._id}
                                name="clear"
                                checked={inventoryfilterdata.metal.includes(
                                  result?._id,
                                )}
                                onClick={(e) => callfilters(e, "metal")}
                                readOnly
                              />
                              <label
                                className="filter-btn-new-stock-take-scan"
                                htmlFor={result?._id}
                              >
                                {result?.name}
                              </label>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                ) : (
                  ""
                )}

                {filterdata?.stone?.length ? (
                  <div className="filter-customer-modal-single-box">
                    {renderSectionHeader({
                      sectionKey: "stone",
                      title: "Stone",
                      total: filterdata?.stone?.length,
                      selected: inventoryfilterdata?.stone?.length,
                    })}

                    {openSections.stone && (
                      <div className="d-flex flex-wrap filter-customer-modal-alpha filter-customer-modal-label-row ">
                        {filterdata?.stone?.map((result, key) => {
                          return (
                            <div className="com-label-select" key={key}>
                              <input
                                className=""
                                type="checkbox"
                                id={result?._id}
                                value={result?._id}
                                name="clear"
                                checked={inventoryfilterdata.stone.includes(
                                  result?._id,
                                )}
                                onClick={(e) => callfilters(e, "stone")}
                                readOnly
                              />
                              <label
                                className="filter-btn-new-stock-take-scan"
                                htmlFor={result?._id}
                              >
                                {result?.name}
                              </label>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                ) : (
                  ""
                )}

                {filterdata?.size?.length ? (
                  <div className="filter-customer-modal-single-box">
                    {renderSectionHeader({
                      sectionKey: "size",
                      title: "Size",
                      total: filterdata?.size?.length,
                      selected: inventoryfilterdata?.size?.length,
                    })}

                    {openSections.size && (
                      <div className="d-flex flex-wrap filter-customer-modal-alpha filter-customer-modal-label-row ">
                        {filterdata?.size?.map((result, key) => {
                          return (
                            <div className="com-label-select" key={key}>
                              <input
                                className=""
                                type="checkbox"
                                id={result?._id}
                                name="clear"
                                value={result?._id}
                                checked={inventoryfilterdata.size.includes(
                                  result?._id,
                                )}
                                onClick={(e) => callfilters(e, "size")}
                                readOnly
                              />
                              <label
                                className="filter-btn-new-stock-take-scan"
                                htmlFor={result?._id}
                              >
                                {result?.name}
                              </label>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                ) : (
                  ""
                )}

                {filterdata?.status?.length ? (
                  <div className="filter-customer-modal-single-box">
                    {renderSectionHeader({
                      sectionKey: "status",
                      title: "Status",
                      total: filterdata?.status?.length,
                      selected: inventoryfilterdata?.status?.length,
                    })}

                    {openSections.status && (
                      <div className="d-flex flex-wrap filter-customer-modal-alpha filter-customer-modal-label-row ">
                        {filterdata?.status?.map((result, key) => {
                          return (
                            <div className="com-label-select" key={key}>
                              <input
                                className=""
                                type="checkbox"
                                name="clear"
                                id={result?.value}
                                value={result?.value}
                                onClick={(e) => callfilters(e, "status")}
                                checked={inventoryfilterdata.status.includes(
                                  result?.value,
                                )}
                                readOnly
                              />
                              <label
                                className="text-center bg-f2 py-2 rounded-5 px-3 w-auto"
                                htmlFor={result?.value}
                              >
                                {result?.name}
                              </label>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                ) : (
                  ""
                )}

                {custom_filter_enable ? (
                  <div className="filter-customer-modal-single-box">
                    <div
                      className="d-flex align-items-center justify-space-between fw-semibold row-one-wrap filter-section-header"
                      onClick={() => toggleSection("price")}
                    >
                      <div className="d-flex justify-content-between align-items-center w-100">
                        <label>{t("Price")}</label>
                        <div className="filter-section-header-right">
                          <ChevronIcon open={openSections.price} />
                        </div>
                      </div>
                    </div>

                    {openSections.price && (
                      <div className="filter-customer-modal-alpha filter-customer-modal-label-row">
                        <div className="range-area mt-0">
                          <Slider
                            range
                            min={
                              filterdata?.Price?.min
                                ? filterdata?.Price?.min
                                : 0
                            }
                            max={
                              filterdata?.Price?.max
                                ? filterdata?.Price?.max
                                : 1000
                            }
                            value={inventoryfilterdata?.price}
                            onChange={(e) =>
                              setInventoryfilterdata((prevState) => ({
                                ...prevState,
                                price: e,
                              }))
                            }
                          />
                          <div className="range-area-num d-flex justify-content-between">
                            <div className="range-area-num-single">
                              <span className="range-area-num-unit">
                                {inventoryfilterdata?.price[0]}
                              </span>
                            </div>
                            <div className="range-area-num-single">
                              <span className="range-area-num-unit">
                                {inventoryfilterdata?.price[1]}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="com-btn"
                  data-bs-dismiss="modal"
                  onClick={() => {
                    submitfiltter(1, limit, inventoryfilterdata);
                  }}
                >
                  {t("Apply Filters")}
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default NewFilterModal;
